import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { GeomModel } from '../../models/geom.model';
@Component({
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss'],
})
export class MapModalComponent {

  @Input()
  geometries: GeomModel[];

  constructor(protected dialogRef: NbDialogRef<MapModalComponent>) { }

  close(): void {
    this.dialogRef.close();
  }
}
